import { render } from "./ChannelCardItem.vue?vue&type=template&id=23a83b01&scoped=true"
import script from "./ChannelCardItem.vue?vue&type=script&lang=js"
export * from "./ChannelCardItem.vue?vue&type=script&lang=js"

import "./ChannelCardItem.vue?vue&type=style&index=0&id=23a83b01&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a83b01"]])

export default __exports__